import { getEnv } from '@ctct/ctct-helpers';

import { BaseApiClient } from '../BaseApiClient';

class ProductSvcApi {
  private baseApiClient: BaseApiClient;

  constructor() {
    const baseUrl = `https://app${getEnv()}constantcontact.com/v1/product`;

    this.baseApiClient = new BaseApiClient(baseUrl);
  }

  public getPlan() {
    return this.baseApiClient.get<unknown>('/planDetails');
  }

  public getUserCount() {
    return this.getEntitlements('USER_MGMT', 'CREATE');
  }

  public getEntitlements(feature: string, activity: string) {
    return this.baseApiClient.get<unknown>(`/entitlements/${feature.toUpperCase()}/${activity.toUpperCase()}`);
  }
}

export const productSvcApi = new ProductSvcApi();
